import React from "react";

import SideNavItem from "./SideNavItem";
import SideNavUtilities from "./SideNavUtilities";

import {
  SideNav,
  SideNavItemsContainer,
  NavItemContainer,
  NavItemsUl,
} from "../styled/Sidebar.styled";

import { menuItems } from "../utils/routes";
import { useVsiAppContext } from "../stores/VsiApp";

export default function Sidebar() {
  const { user, sidebarOpen, setSidebarOpen } = useVsiAppContext();

    const onBurgerClick = () => {
      setSidebarOpen(!sidebarOpen);
    }

  return (
    <SideNav $isOpen={sidebarOpen}>
      <SideNavItemsContainer>
        <NavItemContainer $isNavOpen={sidebarOpen}>
          <i className={"fa solid fa-bars"} style={{ cursor: 'pointer'}} onClick={onBurgerClick}/>
        </NavItemContainer>
        <NavItemsUl>
          {menuItems.map((item, i) => {
              return (
                item.roles.includes(user.role) ?
                <SideNavItem  {...item}
                              key={`side-item-${item.title}-${i}`} /> : null)
          })}
        </NavItemsUl>
      <SideNavUtilities />
      </SideNavItemsContainer>
    </SideNav>
  );
}
